import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { BookingOverview } from './../models/booking-overview.model';
import { BookingApproveModel } from './../models/booking-approve.model';
import { Component, OnInit, ViewChild } from '@angular/core';
import { BookingService } from './../models/booking.service';
import { Router, ActivatedRoute } from '@angular/router';
import { IKeyValueInterface } from './../../shared/config';
import { Location } from '@angular/common';

@Component({
  selector: 'wego-approve-booking',
  template: require('../views/booking-approve.component.html'),
  providers: [BookingService, AuthService, TranslateService],
  styles: [
    `
      span.label.label-default {
        font-size: 13px;
        line-height: 35px;
        background-color: #eeeeee;
        color: #2ba2aa;
        margin-right: 5px;
      }

      span.label.label-default.text-success {
        color: #3c763d;
      }

      span.label.label-default.text-danger {
        color: #a94442;
      }
    `
  ]
})
export class BookingApproveComponent implements OnInit {
  @ViewChild('childModal') public childModal: any;
  @ViewChild('successPopup') public successPopup: any;

  private bookingOverview: BookingOverview;
  private sub: any;
  isLoading: boolean;
  apiErrorMsg: string;
  bookingMasterHashId: string;
  confirmMessage: string;
  errorModel: IKeyValueInterface[];
  bookingApproveModel: BookingApproveModel;
  isPending: boolean = false;
  isReccuring: boolean = false;
  infoMsg: string;
  private popupMsg: string;
  private module: string;
  lblApproveReject: string;
  lblApprove: string;
  lblReject: string;

  constructor(
    private authService: AuthService,
    private bookigService: BookingService,
    private router: Router,
    private translate: TranslateService,
    private activeRoute: ActivatedRoute,
    private locationService: Location,
  ) { }

  ngOnInit() {
    if (this.authService.isLoggedIn()) {
      this.translate.setDetectedLang();
      this.lblApprove = this.translate.instant('LblApprove');
      this.lblReject = this.translate.instant('LblReject');
      this.module = this.translate.instant('LblBooking');
      this.bookingOverview = new BookingOverview();
      this.bookingApproveModel = new BookingApproveModel();
      this.sub = this.activeRoute.params.subscribe(params => {
        this.bookingMasterHashId = params['bookingHashId'] || '';
        this.isReccuring = params['isReccuring'] || '';
        this.bookingApproveModel.isReccuring = this.isReccuring;
        this.GetBookingDetails();
      });
      this.bookingApproveModel.bookingMasterHashId = this.bookingMasterHashId;
    } else {
      this.authService.Logout();
      this.authService.redirectMsg = "";
      this.router.navigate(["/"]);
    }
  }

  private OnConfirmBooking($event: any) {
    //this.successPopup.show();
    console.log(this.bookingApproveModel);
    this.lblApproveReject = this.bookingApproveModel.isApproved
      ? this.lblApprove
      : this.lblReject;
    this.ApproveBookingRequest();
  }

  private OnCancelBooking($event: any) {
    this.router.navigate(["/admin/dashboard"]);
    window.close();
  }

  private GetBookingDetails() {
    this.isLoading = true;
    this.bookigService
      .GetBookingDetails(this.bookingMasterHashId, this.isReccuring)
      .subscribe(
        res => {
          this.isLoading = false;
          if (res.data) {
            this.bookingOverview = res.data;
            this.isPending = true;
          } else {
            this.infoMsg = res.error;
          }
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public ApproveBookingRequest() {
    this.bookigService
      .ApproveBookingRequest(this.bookingApproveModel)
      .subscribe(
        res => {
          if (res.data) {
            this.popupMsg = this.translate.instant(
              'LblBookingApproveRejectSuccess',
              [this.module, this.lblApproveReject]
            );
            this.ShowSuccessPopup();
          } else {
            this.errorModel = res.error;
          }
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }
  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
    window.close();

    this.router.navigate(["/admin/dashboard"]);

  }

  public CloseWindow(): void {
    window.close();
  }

  public GroupByCategory(vehicleAttributeList: any) {
    if (vehicleAttributeList) {
      let prop = 'vehicleAttributeCategoryName';
      return vehicleAttributeList.reduce(function (groups: any, item: any) {
        let val = item[prop];
        groups[val] = groups[val] || [];
        groups[val].push(item);
        groups[val] = groups[val].sort((obj1: any, obj2: any) => {
          if (obj1.attributeName > obj2.attributeName) {
            return 1;
          }

          if (obj1.attributeName < obj2.attributeName) {
            return -1;
          }
          return 0;
        });
        return groups;
      }, {});
    } else {
      return {};
    }
  }

  public KeyOfObject(obj: any) {
    return Object.keys(obj);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/booking/components/booking-approve.component.ts